// extracted by mini-css-extract-plugin
export default {"wrapper":"ImgWithFallbackInMarkdown_wrapper__4BgNA"};